import 'css-chunksrc/client/scenes/optimizedGantt/calendar/dailyMonths/styles.scss';export default {
  "months": "_months_nv4l7_1",
  "month": "_month_nv4l7_1"
};